import { useEffect, useState } from 'react';
import Ikon from '../ui/Ikon';
import { kur, kurulumSus, usePwa, yeniSurumeGec } from './durum';

/** iOS'ta kurulum adımları (tarayıcı istemi yoktur). */
export function IosAdimlar() {
  return (
    <ol className="ccd-kur-adim">
      <li><span>1</span><div>Safari'nin alt çubuğundaki <b>Paylaş</b> düğmesine dokunun <span className="ccd-kur-paylas" aria-hidden="true"><Ikon ad="paylas" boy={18} /></span></div></li>
      <li><span>2</span><div>Listeyi kaydırıp <b>Ana Ekrana Ekle</b>'yi seçin</div></li>
      <li><span>3</span><div>Sağ üstte <b>Ekle</b>'ye dokunun — simge ana ekrana gelir</div></li>
    </ol>
  );
}

/**
 * Kurulum kartı: ilk girişten kısa süre sonra, bir kez. "Daha sonra" 30 gün susturur.
 * Zaten kurulu (standalone) açılmışsa ya da tarayıcı kurulumu desteklemiyorsa görünmez.
 */
export function KurulumKarti({ engel }: { engel?: boolean }) {
  const p = usePwa();
  const [gorunur, setGorunur] = useState(false);
  const [kapandi, setKapandi] = useState(false);
  const uygun = !p.kurulu && (p.istemVar || p.ios) && !kapandi;

  useEffect(() => {
    if (!uygun || engel || kurulumSus.suskunMu()) { setGorunur(false); return; }
    // Sayfa otursun, kullanıcı ilk ekranı görsün: kart araya girmez.
    const z = window.setTimeout(() => setGorunur(true), 4000);
    return () => window.clearTimeout(z);
  }, [uygun, engel]);

  if (!gorunur || !uygun) return null;
  const sonra = () => { kurulumSus.yaz(); setKapandi(true); };
  const simdi = async () => { const s = await kur(); if (s !== 'kabul') kurulumSus.yaz(); setKapandi(true); };

  return (
    <div className="ccd-kur-kart" role="dialog" aria-label="Uygulamayı ana ekrana ekle">
      <div className="ccd-kur-ust">
        <img src="/ikon-192.png" alt="" width={44} height={44} className="ccd-kur-ikon" />
        <div className="ccd-kur-metin">
          <b>Art Mozaik'i ana ekrana ekleyin</b>
          <span>Uygulama gibi açılır: adres çubuğu yok, tek dokunuşla stok ve tahsilat.</span>
        </div>
      </div>
      {p.ios && !p.istemVar && <IosAdimlar />}
      <div className="ccd-kur-dugmeler">
        <button type="button" className="ccd-btn ccd-btn-ghost" onClick={sonra}>Daha sonra</button>
        {p.istemVar
          ? <button type="button" className="ccd-btn ccd-btn-primary" onClick={() => void simdi()}>Ana ekrana ekle</button>
          : <button type="button" className="ccd-btn ccd-btn-primary" onClick={sonra}>Anladım</button>}
      </div>
    </div>
  );
}

/** Ayarlar / kullanıcı menüsündeki kalıcı satır: her zaman erişilir. */
export function KurulumSatiri() {
  const p = usePwa();
  const [adim, setAdim] = useState(false);
  const [not, setNot] = useState<string | null>(null);
  const tikla = async () => {
    setNot(null);
    if (p.istemVar) { const s = await kur(); if (s === 'ret') setNot('Kurulum iptal edildi. İstediğiniz zaman buradan yeniden deneyebilirsiniz.'); return; }
    setAdim((a) => !a);
  };
  return (
    <section className="ccd-card ccd-stack ccd-kur-satir" id="uygulama">
      <div className="ccd-row-between ccd-kur-satir-ust">
        <div style={{ minWidth: 0 }}>
          <h2 className="ccd-heading">Uygulamayı kur</h2>
          <div className="ccd-meta">
            {p.kurulu ? 'Kurulu — şu an ana ekrandan açtığınız uygulamadasınız.'
              : 'Paneli telefonun ana ekranına ekleyin; adres çubuğu olmadan, uygulama gibi açılır. Mağazadan indirme gerekmez.'}
          </div>
        </div>
        {!p.kurulu && (
          <button type="button" className="ccd-btn ccd-btn-primary" onClick={() => void tikla()}>
            {p.istemVar ? 'Ana ekrana ekle' : adim ? 'Adımları gizle' : 'Nasıl kurulur?'}
          </button>
        )}
      </div>
      {not && <div className="ccd-meta" role="status">{not}</div>}
      {!p.kurulu && adim && !p.istemVar && (p.ios ? <IosAdimlar /> : (
        <ol className="ccd-kur-adim">
          <li><span>1</span><div>Tarayıcının menüsünü açın (Chrome'da sağ üstteki <b>⋮</b>)</div></li>
          <li><span>2</span><div><b>Ana ekrana ekle</b> ya da <b>Uygulamayı yükle</b>'yi seçin</div></li>
          <li><span>3</span><div>Onaylayın — simge ana ekrana gelir. Seçenek yoksa tarayıcınız kurulumu desteklemiyor ya da panel zaten kurulu.</div></li>
        </ol>
      ))}
      {p.surum && <div className="ccd-meta ccd-kur-surum">Sürüm {p.surum}</div>}
    </section>
  );
}

/** "Yeni sürüm hazır — Yenile": kendiliğinden yenilenmez (açık formda veri kaybı olmasın). */
export function YeniSurumCubugu() {
  const p = usePwa();
  const [gizli, setGizli] = useState(false);
  if (!p.yeniSurum || gizli) return null;
  return (
    <div className="ccd-surum-cubuk" role="status" aria-live="polite">
      <span className="ccd-surum-metin"><b>Yeni sürüm hazır.</b> Kaydetmediğiniz bir şey varsa önce kaydedin.</span>
      <button type="button" className="ccd-btn ccd-btn-primary ccd-btn-sm" onClick={yeniSurumeGec}>Yenile</button>
      <button type="button" className="ccd-surum-kapat" aria-label="Şimdi değil" title="Şimdi değil" onClick={() => setGizli(true)}><Ikon ad="kapat" boy={18} /></button>
    </div>
  );
}

/** Bağlantı kesilince üstte ince şerit: rakamların güncel olmayabileceği açıkça söylenir. */
export function BaglantiSeridi() {
  const p = usePwa();
  if (!p.cevrimdisi) return null;
  return <div className="ccd-baglanti-serit" role="status">Bağlantı yok — rakamlar güncellenmiyor, kayıt yapılamaz.</div>;
}

/** Açılışta sunucuya ulaşılamadı: oturum silinmez, kullanıcı yeniden dener. */
export function BaglantiYok({ yenidenDene, bekliyor }: { yenidenDene: () => void; bekliyor: boolean }) {
  const p = usePwa();
  return (
    <div className="ccd">
      <div className="ccd-authwrap">
        <div className="ccd-card ccd-authcard ccd-stack ccd-baglanti-yok" role="alert">
          <div className="ccd-baglanti-ikon" aria-hidden="true"><Ikon ad="baglanti-yok" boy={28} /></div>
          <div>
            <div className="ccd-eyebrow">Art Mozaik Panel</div>
            <h1 className="ccd-title">Bağlantı yok</h1>
          </div>
          <p className="ccd-meta">
            {p.cevrimdisi ? 'Telefon çevrimdışı görünüyor.' : 'Sunucuya ulaşılamadı.'} Panel güncel veriyle çalışır; eski rakam göstermez.
            Bağlantı gelince yeniden deneyin — oturumunuz açık kalır.
          </p>
          <button type="button" className="ccd-btn ccd-btn-primary ccd-btn-block" onClick={yenidenDene} disabled={bekliyor}>
            {bekliyor ? 'Deneniyor…' : 'Yeniden dene'}
          </button>
        </div>
      </div>
    </div>
  );
}
